<template>
  <div class="table-page-search-wrapper">
    <a-form layout="inline">
      <a-row :gutter="48">
        <a-col :md="8" :sm="24">
          <a-form-item>
            <a-select
              :allowClear="true"
              v-model="searchModel.type"
              showSearch
              optionFilterProp="children"
              :filterOption="filterOption"
              placeholder="请选择题型"
            >
              <a-select-option v-for="(item, index) in subjectType" :value="item.code" :key="index">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :md="8" :sm="24">
          <a-form-item>
            <a-input placeholder="请输入题目关键字" autocomplete="off" v-model="searchModel.title" />
          </a-form-item>
        </a-col>
        <a-col :md="8" :sm="24">
          <span class="table-page-search-submitButtons">
            <a-button type="primary" @click="search">查询</a-button>
            <a-button style="margin-left: 8px" @click="clearSearch">重置</a-button>
          </span>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SubjectSearchForm',
  data () {
    return {
      searchModel: {
        type: undefined,
        title: undefined
      }
    }
  },
  computed: mapGetters(['subjectType']),
  methods: {
    // 点击查询按钮
    search () {
      const searchInfo = {}
      this.searchModel.type = this.searchModel.type ? (searchInfo.type = this.searchModel.type) : ''
      this.searchModel.title = this.searchModel.title ? (searchInfo.title = this.searchModel.title.trim()) : ''
      this.$emit('setSearchCondition', searchInfo)
    },
    // 点击复位按钮
    clearSearch () {
      this.searchModel = {
        type: undefined,
        title: undefined
      }
      this.$emit('clearSearch', this.searchInfo)
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  }
}
</script>
